<template>
  <div id="otherSolutionModal">
    <div class="modal fade" :class="{'in': isVisible, 'open': isVisible}" role="dialog"
         aria-labelledby="otherSolutionModal" tabindex="-1">
      <div class="other-solution-modal modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close pull-right" @click="close()" data-dismiss="modal"
                        aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="navigation-buttons pull-right">
                    <button class="btn btn-secondary navigation-button navigation-back-button" :class="{'disabled': previousIndex === -1}"
                            @click="showSolution(previousIndex)"><i
                        class="fa fa-chevron-left"></i></button>
                    <button class="btn btn-secondary navigation-button navigation-next-button" :class="{'disabled': nextIndex === -1}"
                            @click="showSolution(nextIndex)"><i
                        class="fa fa-chevron-right"></i></button>
                </div>
                 <div class="challenge-title-wrapper">
                        <div class="challenge-title">{{ challengeData.title }} ({{ challengeData.technology.language }})</div>
                        <div v-if="taskSolutions.length > 1" class="tasks-solutions">
                            <span v-for="(taskSolution, index) in taskSolutions"
                                  class="task-solution-link"
                                  :aria-disabled="!taskSolution.solutionId"
                                  :class="{'disabled': !taskSolution.solutionId,'selected': taskSolution.solutionId === solutionData.solutionId}"
                                  :key="'task-solution-' + index"
                                  @click="showTaskSolution(taskSolution)">
                              Stage {{ index + 1 }}
                            </span>
                        </div>
                    </div>
              <div class="row header-row flex">
                  <div class="col-xs-7 col-sm-4 col-md-6 flex">
                      <router-link target="_blank"
                                   :to="{name: 'public-user-profile', params: {userId: solutionData.publicUserId}}">
                         <span>
                             <img :src="solutionData.profileImage" class="profile-image">
                         </span>
                          <span class="nickname">
                              <strong>{{ solutionData.publicUserName }}</strong>
                         </span>
                      </router-link>
                  </div>
                <div class="hidden-xs col-sm-2">
                  <div class="date">{{ getNiceTime(solutionData.timeSolved) }}</div>
                </div>
                <div class="col-xs-2 col-sm-3 col-md-2 flex comment-col">
                  <span v-if="solutionData.commentCount"><i class="icon dev-chat-dots"></i><span>{{ solutionData.commentCount }} <span class="hidden-xs">Kommentar<span v-if="solutionData.commentCount !== 1">e</span></span></span></span>
                </div>
                <div class="col-xs-4 col-sm-3 flex star-rating-col">
                  <span>
                    <star-rating size="1.6rem" :disabled="true" name="rate"
                                 :value="solutionData.rating"
                    ></star-rating>
                  </span>
                  <span v-if="solutionData.ratingCount > 0" class="rating">
                    {{ solutionData.rating.toFixed(1) }} ({{ solutionData.ratingCount }})
                  </span>
                  <span v-if="solutionData.ratingCount <= 0" class="rating">0 (0)</span>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-xs-12 col-md-8 col-editor">
                  <new-solution-editor-component
                      ref="solutionEditorComponent"
                      :solutionId="solutionData.solutionId"
                      @userHasSolvedThisChallenge="setUserHasSolvedThisChallenge">
                  </new-solution-editor-component>
                  <rating-form-component
                      ref="solutionRatingForm"
                      v-if="userHasSolvedThisChallenge"
                      :solution-id="solutionData.solutionId"
                      :challenge-id="challengeData.id"
                      @addedRating="addedRatingHandler">
                  </rating-form-component>
                </div>
                <div class="col-xs-12 col-md-4">
                  <solution-ratings-component
                      ref="solutionRatingsComponent"
                      :task-id="solutionData.taskId"
                      :solutionId="solutionData.solutionId"
                      @newCommentAdded="updateCommentCount"
                  >
                  </solution-ratings-component>
                  <code-comments-component
                      @newCommentAdded="updateCommentCount"
                      @highlightCodeComment="highlightCodeComment"
                      @unHighlightCodeComment="removeHighlightCodeComment"
                      ref="codeCommentsComponent"
                      :solutionId="solutionData.solutionId">
                  </code-comments-component>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div @click="close()" class="modal-backdrop fade in" v-if="isVisible"></div>
        <div v-show="isVisible && previousIndex !== -1" class="previous-button-container">
            <div class="button previous" @click="showSolution(previousIndex)">
                <i class="fa fa-chevron-left"/>
            </div>
        </div>
        <div v-show="isVisible && nextIndex !== -1" :disabled="isloadingMoreSolutions" class="next-button-container">
            <div class="button next" @click="showSolution(nextIndex)">
                <i v-if="isloadingMoreSolutions" class="fa fa-spinner fa-spin"/>
                <i v-if="!isloadingMoreSolutions" class="fa fa-chevron-right"/>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
  import StarRating from "../StarRating";
  import SolutionRatingsComponent from "../rank-the-code/SolutionRatingsComponent";
  import RatingFormComponent from "./RatingFormComponent";
  import CodeCommentsComponent from "../rank-the-code/CodeCommentsComponent";
  import NewSolutionEditorComponent from "../rank-the-code/NewSolutionEditorComponent";
  import moment from "moment";
  import {eventBus} from "../../main";

  export default {
      name: "OtherSolutionModal",
      props: {
        isVisible: {type: [Boolean], default: false},
        previousIndex: {type: Number, default: -1},
        nextIndex: {type: Number, default: -1},
        isloadingMoreSolutions: {type: Boolean, default: false},
        solutionData: {
          type: [Object],
          default() {
            return {}
          },
        },
        challengeData: {
          type: [Object],
          default() {
            return {}
          },
        },
        taskSolutions: {
          type: Array,
          default: [],
        },
      },
      components: {
        SolutionRatingsComponent,
        StarRating, CodeCommentsComponent, RatingFormComponent, NewSolutionEditorComponent
      },
      data() {
        return {
          userHasSolvedThisChallenge: false,
        }
      },
      methods: {
        showTaskSolution: function(taskSolution) {
          eventBus.$emit('show-task-solution', taskSolution);
        },
        showSolution: function (index) {
          this.$emit("showSolution", index);
        },
        getNiceTime(timestamp) {
          moment.locale("de");
          let dateString = moment(timestamp).format("DD.MM.YY");
          if (moment(timestamp).isSame(moment(), "day")) {
            dateString = moment(timestamp).fromNow();
          }
          return dateString;
        },
        addedRatingHandler: function (data) {
          this.$refs.solutionRatingsComponent.reloadRatings();
          this.$emit('addedRating', data);
        },
        highlightCodeComment(comment) {
          this.$refs.solutionEditorComponent.highlightComment(comment);
          this.$refs.solutionEditorComponent.centerEditorFocus(comment);
        },
        removeHighlightCodeComment(commentsWithUserData) {
          this.$refs.solutionEditorComponent.renderComments(commentsWithUserData);
        },
        setUserHasSolvedThisChallenge(value) {
          this.userHasSolvedThisChallenge = value;
        },
        updateCommentCount: function (amount) {
          this.solutionData.commentCount += amount;
        },
        close() {
          this.$emit('close');
        },
      },
  }
</script>

<style scoped>
.modal-header {
    padding-top: 2rem;
}

.navigation-buttons {
    display: none;
}
.navigation-button {
    font-size: 1rem;
}
.navigation-back-button:hover, .navigation-next-button:hover {
    cursor: pointer;
}

.navigation-next-button {
    margin-left: 0.2rem;
    margin-right: 3rem;
}

.col-editor {
  padding-right: 0;
}
.open {
  display: block;
}

.modal.open {
  z-index: 2200;
}

.header-row {
  font-size: 14px;
}

.nickname {
  overflow-x: hidden;
}

.date {
  font-size: smaller;
  color: grey;
}

.other-solution-modal {
  z-index: 2200;
}

.modal-dialog {
  width: 1500px;
  margin-top: 4rem;
}

@media (max-width: 1500px) {
  .modal-dialog {
    width: 100%;

    margin: 1rem 0 0 0;
  }
}

@media (max-width: 991px) {
  .col-editor {
    padding-right: 15px;
  }
}

.challenge-title-wrapper {
  display: flex;
}

.challenge-title,
.tasks-solutions {
  color: grey;
  font-size: smaller;
}

.tasks-solutions .task-solution-link {
  cursor: pointer;
  margin: 0 1rem;
  padding: 1rem 3rem;
  border-radius: 10px;
  transition: all 0.25s ease-in-out;
}

.tasks-solutions .task-solution-link.disabled,
.navigation-button.disabled,
.tasks-solutions .task-solution-link.disabled:hover {
  cursor: not-allowed;
  background-color: transparent;
    opacity: 0.5;
}

.tasks-solutions .task-solution-link:hover,
.tasks-solutions .task-solution-link.selected {
  background-color: #D7E8F9;
}

.tasks-solutions .task-solution-link.selected {
  font-weight: bold;
}

@media (max-width: 991px) {
  .challenge-title-wrapper {
    flex-direction: column;
  }
  .tasks-solutions {
      margin-left: -1rem;
      padding-top: 2rem;
      padding-bottom: 2rem;
      margin-right: 0;
  }
  .tasks-solutions .task-solution-link {
      padding: 1rem 2rem;
  }
}


.comment-col {
  justify-content: end;
}

.icon {
  margin-right: .5rem;
  font-size: 1.3rem;
}

.profile-image {
  margin-right: 1rem;
  border-radius: 99px;
  height: 25px;
  width: 25px;
}

.flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.close {
  font-size: 3rem;
}

.close:hover {
  cursor: pointer;
}

.header-row {
    margin-top: 1rem;
}

@media (max-width: 992px) {
    .header-row {
        margin-top: 3rem;
    }
}

.button.previous,
.button.next {
    position: fixed;
    top: 50%;
    transform: translateY(-70%);
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    z-index: 2500;
    width: 200px;
    margin: 1rem;
    font-size: 4.5rem;
    color: black;
    opacity: 0.6;
    cursor: pointer;
    transition: all 0.25s ease-in-out;
}

.button.previous .fa,
.button.next .fa {
}

.button.previous:hover,
.button.next:hover {
    opacity: 1;
}

.button.previous {
  left: 3%;
}

.button.next {
  right: 3%;
}

@media (max-width: 1980px) {
  .button.previous,
  .button.next {
    display: none;
  }

  .navigation-buttons {
      display: block;
  }
}

@media (max-width: 500px) {
  .rating {
    margin-left: 1rem;
  }
  .challenge-title-wrapper {
    display: block;
  }
  .tasks-solutions {
    margin-top: 1rem;
  }
  .button.previous,
  .button.next {
    display: none;
  }
}

@media (max-width: 450px) {
  .rating {
    display: none;
  }
}

</style>
